import { EmptyState, Fieldset, VStack } from '@chakra-ui/react'
import type { FC } from 'react'
import { useEffect } from 'react'

import useTrack from '@app/hooks/useTrack'
import type { DashboardItem } from '@app/pages/aiDashboard/types'
import MessageContent from '@app/pages/strategies/components/aiChat/components/messageContent'

const blockMatch = (message: string) => ({
  block: null,
  priority: null,
  llmOutput: null,
  isComplete: true,
  startIndex: 0,
  endIndex: 0,
  outputRaw: null,
  visibleText: null,
  isVisible: true,
  output: message
})

interface Props {
  report?: DashboardItem['reports'][0]
}

const AiDashboardReport: FC<Props> = ({ report }) => {
  const track = useTrack()

  useEffect(() => {
    const now = Date.now()

    return () => {
      if (report) {
        track('report:viewed', {
          reportId: report.id,
          reportName: report.name,
          duration: Date.now() - now
        })
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!report) {
    return (
      <EmptyState.Root>
        <EmptyState.Content>
          <VStack textAlign="center">
            <EmptyState.Title>No report yet</EmptyState.Title>
            <EmptyState.Description>Click "Run now" to generate the report.</EmptyState.Description>
          </VStack>
        </EmptyState.Content>
      </EmptyState.Root>
    )
  }

  return (
    <Fieldset.Root borderWidth={1} borderStyle="solid" borderColor="border.default" borderRadius="md" p={6}>
      <Fieldset.Content>
        <MessageContent blockMatch={blockMatch(report.summary || 'No summary for the most recent report')} />
      </Fieldset.Content>
    </Fieldset.Root>
  )
}

export default AiDashboardReport
